import { render, staticRenderFns } from "./AttestationNeuropsy.vue?vue&type=template&id=121cb013"
import script from "./AttestationNeuropsy.vue?vue&type=script&lang=js"
export * from "./AttestationNeuropsy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports